<template>
    <div class="content mt20">
        <div class="account-content bgfff">
            <dataAnalysisMenu></dataAnalysisMenu>
        </div>
        <div class="account-bd">&nbsp;</div>
        <div class="account-content bgfff" style="position:relative;">
            <div class="one-bd clearfix">
                <div class="fl">
                    <router-link to="/wxdataAnalysis" exact>我的业绩</router-link>
                    <router-link to="/wxdataAnalysis/myFans">我的粉丝</router-link>
                    <router-link to="/wxdataAnalysis/myArticle">我的文章</router-link>
                </div>
                <div class="btn-warp fr">
                    <button class="btn btn-blue" @click="selectPublic"><i class="icons jiaohu-icon"></i>选择其他媒体号</button>
                </div>
            </div>
            <div class="select-public" :class="(Active?'':'hide')" id="ghList">
                <div class="select-warp">
                    <div class="close fr" @click="closeModal"><img src="/static/images/close.png" ></div>
                    <div class="one-bd clearfix">
                        <div class="search fl">
                            <input type="text" v-model="sel" class="input-text" name="search" placeholder="请输入用户名/手机号">
                        </div>
                        <button class="btn btn-blue" @click="searchButton"><i class="icons search-icon"></i></button>
                    </div>
                    <div class="gh-warp clearfix mt20" id="ghWarpList">
                        <div class="img-word" v-for="(item,index) in selectPList" :key="index" @click="clickPublic(item.id)">
                            <img :src="item.headImg" class="img"/>
                            <div class="word">
                                <div class="in">
                                    <span class="name db">{{item.nickname}}</span>
                                    <span class="en-name db">{{item.alias}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="xinxi-header mt30 clearfix">
                <div class="img-word fl">
                    <img :src="wxInfo.headImg" class="img"/>
                    <i class="icons wx-icon"></i>
                    <div class="word">
                        <div class="in">
                            <span class="name">{{wxInfo.nickname}}</span>
                            <span class="en-name">{{wxInfo.alias}}</span>
                        </div>
                    </div>
                </div>
                <div class="rank-item  clearfix fl">
                    <div class="item fl">
                        <span class="rank-num db">{{wxInfo.rank}}</span>
                        <span class="rank-word db">总排名 <span :class="[{'color-red':parseInt(wxInfo.rankUp)>0},{'cr1ab968':parseInt(wxInfo.rankUp)<0},{'color-gray':parseInt(wxInfo.rankUp)==0}]"><i class="icons" :class="parseInt(wxInfo.rankUp)>0 ? ' icon-up1' : ' icon-down1'" v-if="!wxInfo.rankUp==0"></i>{{wxInfo.rankUp}}</span></span>
                    </div>
                </div>
            </div>
       </div>
       <div class="account-bd">&nbsp;</div>
       <div class="bgfff">
            <div class="bd clearfix">
                <div class="title fl">{{startTime}}~{{endTime}} 文章分析</div>
                <div class="control-right fr">
                    <div class="form-group w210 form-time fl">
                        <vue-datepicker-local v-model="timeRange" format="YYYY-MM-DD" :disabled-date="disabledDate"  show-buttons  @confirm="selectedDate"/><i class="icons date-icon fr"></i>
                    </div>
                    <!-- <button class="btn ml10 btn-blue fl" @click="dateSearch"><i class="icons search-icon"></i></button> -->
                </div>
            </div>
            <div class="container-body mt20">
                <div class="plane">
                    <div class="plane-header">
                        <ul class="fl"> 
                            <li>业绩列表</li>
                        </ul>
                        <div class="mr20 fr">
                            <a :href="downLoadUrl" download=""><i class="icons download-icon"></i>下载数据</a>
                        </div>
                    </div>
                    <div class="no-data" v-if="nodata"><span class="text">没有数据哦...</span></div>
                    <div class="plane-body clearfix" v-if="!nodata">
                        <table class="table" width="100%" border="0" cellpadding="0" cellspacing="0">
                            <colgroup>
                                <col width="20%">
                                <col width="10%">
                                <col width="10%">
                                <col width="10%">
                                <col width="12%">
                                <col width="14%">
                                <col width="10%">
                                <col width="12%">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th class="al">文章标题</th>
                                    <th><span class="th-span up">阅读数/人数 </span></th>
                                    <th><span class="th-span down">收藏数/人数 </span></th>
                                    <th><span class="th-span">转发数/人数</span></th>
                                    <th><span class="th-span">原文点击数/人数 </span></th>
                                    <th><span class="th-span">朋友圈转发数/人数 </span></th>
                                    <th><span class="th-span">日期</span></th>
                                    <th>操作</th>
                                </tr>
                            </thead>
                            <tbody v-for="(item,index) in mediaList" :key="index" >
                                <tr class="table-tr">
                                    <td><span class="al ovhidden w210"><span class="box-red-tips" v-if="(item.top==1)">头条</span>{{item.title}}</span></td>
                                    <td>{{item.pageReadCount}}/{{item.pageReadUser}}</td>
                                    <td>{{item.favCount}}/{{item.favUser}}</td>
                                    <td>{{item.shareCount}}/{{item.shareUser}}</td>
                                    <td>{{item.oriReadCount}}/{{item.oriReadUser}}</td>
                                    <td>{{item.feedCount}}/{{item.feedUser}}</td>
                                    <td>{{item.refDate}}</td>
                                    <td class="">
                                        <a class="td-eacher-a color-blue" href="javascript:void(0);" @click="clickDataSurvey(item.id,item,index)">数据概况 <i class="icons dot-bottom"></i></a>
                                    </td>
                                </tr>
                                <tr class="td-eacher" v-show="curr==index">
                                    <td colspan="8">
                                        <div class="echart-warp clearfix">
                                            <div class="echart-pie fl">
                                                <pieChart :id="'pieEchart'+(index+1)" :dataArray="pieChartData" :colorArr="pieColorArr" />
                                            </div>
                                            
                                            <div class="echart-line fl">
                                                <div class="echart-tab">
                                                    <a href="javascript:void(0);" :class="(Current==1?'curr':'')" @click="lineChart1(1)">阅读数</a>
                                                    <a href="javascript:void(0);" :class="(Current==2?'curr':'')" @click="lineChart1(2)">收藏数</a>
                                                    <a href="javascript:void(0);" :class="(Current==3?'curr':'')" @click="lineChart1(3)">转发数</a>
                                                    <a href="javascript:void(0);" :class="(Current==4?'curr':'')" @click="lineChart1(4)">原文点击数</a>
                                                    <a href="javascript:void(0);" :class="(Current==5?'curr':'')" @click="lineChart1(5)">朋友圈转发数</a>
                                                </div>
                                                <lineChart :id="'lineEchart'+(index+1)"  :dataArray="lineChartData"  v-if="lineChartData !=''" />
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <!-- 分页 -->
                <page class="mt20" :currentPage.sync="currentPage" :limit.sync="limit" :totalCount="totalCount" @turn="getTableData"></page>
            </div>
       </div>
  	</div>
</template>
<script>
import VueDatepickerLocal from 'vue-datepicker-local'
import lineChart from '@/components/echart/lineChart'
import pieChart from '@/components/echart/pieChart'
import Page from '@/components/page'
import dataAnalysisMenu from './dataAnalysisMenu.vue'
export default {
    components:{
        VueDatepickerLocal,lineChart,Page,pieChart,dataAnalysisMenu
    },
    data() {
		var min = new Date()
    	var max = new Date()
		min.setMonth(min.getMonth()-1);
		
        return {

           mediaList:[],//微信列表
           wxInfo:[],//微信信息
           wxfans:[],//粉丝状况
           downLoadUrl:[],//下载地址
           currentPage:1,//当前条数
           limit:10,//每页显示条数
           totalCount:0,//总条数
           currentTab:'day',//时间
           //typeCurrent:'day',//选择时间当前类型
           dateWeek:'',//周
           dateMonth:'',//月
           dateOne:'',//默认时间week month
           //dateOne2:'',//默认时间month
          // timeRange:'',//默认day
            min:min,
            max:max,
            timeRange: [min,max],
            Current:1,
            lineChartData:[],//echart线性图表数据
            pieChartData:[],//echart饼图图表数据
            pieChart:[],
            pieChartData1:[],
            Active:false,
            selectPList:[],//选择公众号列表
            Id:'',//公众号id
            sel:'',//搜索绑定值
            startTime:'',
            endTime:'',
            id1:'',//文章id
            pieColorArr:['#2799df','#31d1d6','#6ed495','#f56262','#ffaf54'],
            readUser:'',
            readUser1:'',
            readCount:'',
            readCount1:'',
            favUser:'',
            favCount:'',
            shareUser:'',
            shareCount:'',
            oriUser:'',
            oriCount:'',
            feedUser:'',
            feedCount:'',
            curr:-1,
            datetime:'', 
            nodata:false,
        }
    },
    mounted() {
        let that = this;
        if(that.$route.query.type){
            that.startTime = that.$route.query.type;
            that.endTime = that.$route.query.type1;
        }else{
            that.startTime = that.$utils.dateConversion(that.timeRange[0],0); 
            that.endTime = that.$utils.dateConversion(that.timeRange[1],0); 
        }
		if(that.$parent.mediaId==''){
			that.Id=that.Id;
		}else{
			that.Id=that.$parent.mediaId;
		}
        console.log(that.$parent.mediaId);
        that.dataAjax(0);
        that.$nextTick(()=> {
            //that.lineChartAjax();
        })
    },
    created() {
		
    },
    methods: {
        clickDataSurvey(id,item,index){//点击展开数据概况
            let that = this;
            that.id1= id;
            that.Current = 1;
            that.dataAjax2();
            that.curr = that.curr == index ? -1 : index;            
        },
        dateSearch(){//搜索
            let that = this;
            that.dataAjax(0);
        },
        getTableData(type){//分页
            let that = this;
            type = that.currentPage;
            that.curr = -1;
            that.dataAjax(0);
        },
        closeModal(){//关闭公众号弹框
            let that = this;
            that.Active =false;
        },
        searchButton(){//搜索公众号
            let that = this;
            that.selectPublic();
            that.Active =true;
        },
        clickPublic(id){//点击公众号
            let that = this;
            that.Id= that.$parent.mediaId = id;
			console.log( that.$parent.mediaId);
            that.dataAjax(0);
            that.Active = !that.Active;
        },
        selectPublic(){//选择公众号
            let that = this;
            that.Active = !that.Active;
            that.$api.post('/member/accountlist',{search:that.sel,type:1},r=>{
                that.$parent.returnCode(r,function(){
                    that.selectPList = r.data.list;
                })
            })
        },
        lineChart1(type){//线性图表点击切换
            let that = this;
            that.Current = type;
            that.lineChartAjax(type);
        },
        pieChartAjax(){//饼状图
            
            this.pieChartData = this.pieChartData;
        },
        lineChartAjax(type){//线性图表
            let that = this;
            console.log(1);
            type = that.Current;
            if(type == 1){
                let newData = {
                    "dataName":['阅读人数','阅读次数'],
                    "阅读人数":that.readUser1,
                    "阅读次数":that.readCount1,
                    "datetime":that.datetime
                };
                that.lineChartData = newData;
            }else if(type == 2){
                let newData = {
                    "dataName":['收藏人数','收藏次数'],
                    "收藏人数":that.favUser,
                    "收藏次数":that.favCount,
                    "datetime":that.datetime
                };
                that.lineChartData = newData;
            }else if(type == 3){
                let newData = {
                    "dataName":['转发人数','转发次数'],
                    "转发人数":that.shareUser,
                    "转发次数":that.shareCount,
                    "datetime":that.datetime
                };
                that.lineChartData = newData;
            }else if(type == 4){
                let newData = {
                    "dataName":['原文阅读人数','原文阅读次数'],
                    "原文阅读人数":that.oriUser,
                    "原文阅读次数":that.oriCount,
                    "datetime":that.datetime
                };
                that.lineChartData = newData;
            }else if(type == 5){
                let newData = {
                    "dataName":['朋友圈阅读人数','朋友圈阅读次数'],
                    "朋友圈阅读人数":that.feedUser,
                    "朋友圈阅读次数":that.feedCount,
                    "datetime":that.datetime
                };
                that.lineChartData = newData;
            }
            
            
        },
       disabledDate(time,format){
            let that = this;
           if(time.getTime() > new Date().getTime()) return true;
        },
        selectedDate (date) {//点击时间确定
            let that = this;
            that.startTime = that.$utils.dateConversion(that.timeRange[0],0); 
            that.endTime = that.$utils.dateConversion(that.timeRange[1],0);
            that.$router.push({
                path: '/wxdataAnalysis/myArticle',
                query: {
                    type: that.startTime,
                    type1:that.endTime
                }
            });
            that.startTime = that.$route.query.type;
            that.endTime = that.$route.query.type1;

            that.dataAjax(0);
            
        },
        dataAjax(page){//微信列表
            let that = this;
            let url = '';
            that.$parent.loadModal(true,'正在加载...');
            that.$api.post('/datacube/wxarc',{page:that.currentPage,pagesize:that.limit,id:that.Id,data:that.startTime+'~'+that.endTime},r=>{
                that.$parent.showLoad = false;
                that.$parent.returnCode(r,function(){
                    that.mediaList= r.data.list;
                    that.wxInfo = r.data.info;
                    that.datetime = r.data.date;
                    that.totalCount = parseInt(r.data.total);
                    that.downLoadUrl = r.data.downloadUrl;
                    if(that.mediaList<=0){
                        that.nodata = true;
                    }else{
                        that.nodata = false;
                    }
              })
            })
       },
        dataAjax2(){//数据概况
            let that = this;
            that.$parent.loadModal(true,'正在加载...');
            that.$api.post('/datacube/wxarcdetail',{id:that.id1},r=>{
                that.$parent.showLoad = false;
                that.$parent.returnCode(r,function(){
                    that.pieChart = r.data.readSource;
                    that.readUser = that.pieChart.readUser;
                    that.readCount = that.pieChart.readCount;
                    that.pieChartData = r.data.readSource.readFenbu;
                    that.readUser1= r.data.readUser;
                    that.readCount1= r.data.readCount;
                    that.favUser= r.data.favUser;
                    that.favCount= r.data.favCount;
                    that.shareUser= r.data.shareUser;
                    that.shareCount= r.data.shareCount;
                    that.oriUser= r.data.oriUser;
                    that.oriCount= r.data.oriCount;
                    that.feedUser= r.data.feedUser;
                    that.feedCount= r.data.feedCount;
                    that.datetime= r.data.date;
                    that.lineChartAjax();
                    that.pieChartAjax();
                    
                })
            })
       }
       
	}
}
</script>



// WEBPACK FOOTER //
// src/page/dataAnalysis/myArticle.vue